import React, { useState, useEffect, useMemo, useRef } from 'react';
import {
    Box,
    Typography,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableRow,
    Button,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    Grid,
    Snackbar,
    Alert,
    Modal, Backdrop, CircularProgress,
    TextField,
    Checkbox,
    FormControlLabel, Dialog, DialogTitle, DialogContent, DialogActions
} from '@mui/material';
import { Download } from '@mui/icons-material';
import axios from 'axios';
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import moment from 'moment';
import { saveAs } from 'file-saver';
import { IconButton } from '@mui/material';
import { Close } from '@mui/icons-material';
import 'moment/locale/pt';  // Importar a localidade para português
import '../App.css';
import './Folhasdepresenca.css';
import { summarizeOvertime, getDayAttendance } from '../utils/attendance';
import AttendanceDayDetails from './AttendanceDayDetails';


moment.locale('pt');


const Folhasdepresençav2 = () => {
    const [empregados, setEmpregados] = useState([]);
    const [selectedEmpregado, setSelectedEmpregado] = useState(null);
    const [ano, setAno] = useState(moment().year());
    const [mes, setMes] = useState(moment().month() + 1); // Mês atual
    const [selectedDates, setSelectedDates] = useState([]);
    const [horasExtrasRecords, setHorasExtrasRecords] = useState([]);
    const [baixasMedicas, setBaixasMedicas] = useState([]);
    const [attendanceReady, setAttendanceReady] = useState(false);
    const [refreshVersion, setRefreshVersion] = useState(0);
    const [focusedDate, setFocusedDate] = useState(null);
    const [turnosRecords, setTurnosRecords] = useState([]);
    const [feriasRecords, setFeriasRecords] = useState([]);
    const [distributionType, setDistributionType] = useState('semana');
    const viewContextRef = useRef('');
    const [distributionOpen, setDistributionOpen] = useState(false);
    const [distributionTotal, setDistributionTotal] = useState('');
    const [distributionPreview, setDistributionPreview] = useState(null);
    const [distributionBusy, setDistributionBusy] = useState(false);
    const [distributionError, setDistributionError] = useState('');
    const [ferias, setFerias] = useState([]);
    const [faltas, setFaltas] = useState([]);
    const [turno, setTurno] = useState('normal');
    const [empregadosAlterados, setEmpregadosAlterados] = useState([]);
    const [alert, setAlert] = useState({ open: false, message: '', severity: 'success' });
    const [modalOpen, setModalOpen] = useState(false);
    const [isFullDay, setIsFullDay] = useState(false); // Novo estado para controlar a checkbox "Dia inteiro"
    const [alteredDays, setAlteredDays] = useState([]);
    const years = Array.from({ length: moment().year() - 2020 + 1 }, (_, i) => 2020 + i);
    const [loading, setLoading] = useState(false);
    const [newFalta, setNewFalta] = useState({
        dia: '',
        tipo_falta: 'injustificada', // Definir "Injustificada" como padrão
        horario_inicio: '',
        horario_fim: '',
        documento_justificacao: null,
    });
    const [isHolidayModalOpen, setIsHolidayModalOpen] = useState(false); // Controla a abertura e fechamento do modal
    const [holidayName, setHolidayName] = useState(''); // Armazena o nome do feriado inserido
    const [isHalfDay, setIsHalfDay] = useState(false); // Estado para controlar se é meio dia
    const [openAddModal, setOpenAddModal] = useState(false);
    const [searchTerm, setSearchTerm] = useState(""); // Estado para armazenar o termo de pesquisa
    const [newHoraExtra, setNewHoraExtra] = useState({
        data: '',
        horas_trabalhadas: '',
        justificativa: '',
    });
    
    const [isMultiDaySelection, setIsMultiDaySelection] = useState(false); // Controle da checkbox
    const [manualHolidays, setManualHolidays] = useState([]); // Estado para armazenar feriados manualmente adicionados
    const [startDate, setStartDate] = useState(null); // Data de início para a seleção múltipla
    const [feriados, setFeriados] = useState([]); // Inicializa o estado dos feriados
    const [faltaModalOpen, setFaltaModalOpen] = useState(false); // Controla a abertura da modal da falta
    const [selectedFalta, setSelectedFalta] = useState(null); // Armazena os detalhes da falta selecionada

    const horasExtras = useMemo(
        () => summarizeOvertime(horasExtrasRecords, [...feriados, ...manualHolidays]),
        [horasExtrasRecords, feriados, manualHolidays]
    );
    const horasExtrasDates = horasExtrasRecords.map(record => moment(record.data).toDate());

    const viewContext = `${selectedEmpregado?.id}:${ano}:${mes}`;
    viewContextRef.current = viewContext;
    const dayDetails = focusedDate && selectedEmpregado ? getDayAttendance(focusedDate, {
        employee: selectedEmpregado, overtime: horasExtrasRecords,
        holidays: [...feriados, ...manualHolidays].filter((holiday, index, all) =>
            all.findIndex(item => moment(item.date).isSame(holiday.date, 'day')) === index),
        vacations: feriasRecords, absences: faltas, sickLeave: baixasMedicas, shifts: turnosRecords,
    }) : null;

    const handleDayOvertimeChange = (id, updated) => {
        if (viewContextRef.current !== viewContext) return;
        setHorasExtrasRecords(records => updated ? records.map(record => record.id === id ? updated : record) : records.filter(record => record.id !== id));
        setAlert({ open: true, severity: 'success', message: updated ? 'Horas do dia atualizadas.' : 'Registo de horas removido.' });
    };

    const openDistribution = tipo => {
        setDistributionType(tipo);
        setDistributionTotal('');
        setDistributionPreview(null);
        setDistributionError('');
        setDistributionOpen(true);
    };

    const apiBaseURL = 'https://plasticemployers.duckdns.org';      // IP da rede local

    const csrfToken = document.cookie
  .split('; ')
  .find(row => row.startsWith('csrftoken'))
  ?.split('=')[1];

if (csrfToken) {
    axios.defaults.headers.common['X-CSRFToken'] = csrfToken;
} else {
    console.error('CSRF token not found');
}

    const handleOpenAddModal = () => {
        console.log("Modal de horas extras aberta");  // Adicione isso para verificar
        setOpenAddModal(true);
    };
    
    const handleMarkHoliday = () => {
        if (selectedDates.length) {
            setIsHolidayModalOpen(true);  // Abre o modal para inserir o nome do feriado
        } else {
            setAlert({ open: true, message: 'Selecione um dia primeiro!', severity: 'warning' });
        }
    };

    const handleCloseModals = () => {
        setOpenAddModal(false);
        setModalOpen(false); // Caso também queira fechar o modal de faltas
    };
    
    const handleNewHoraExtraChange = (e) => {
        setNewHoraExtra({
            ...newHoraExtra,
            [e.target.name]: e.target.value,
        });
    };
    const handleCloseHolidayModal = () => {
        setIsHolidayModalOpen(false);
        setHolidayName('');  // Limpa o nome do feriado ao fechar o modal
    };
    
    const fetchFeriados = async () => {
        const token = localStorage.getItem('access');
        try {
            const response = await axios.get(`${apiBaseURL}/api/feriados/`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                }
            });
            
            // Formatar as datas dos feriados como objetos de data
            const fetchedFeriados = response.data.map(feriado => ({
                date: new Date(feriado.data),
                name: feriado.nome
            }));
            
            setFeriados(fetchedFeriados); // Armazena os feriados no estado
        } catch (error) {
            console.error('Erro ao buscar feriados:', error);
        }
    };

    const handleSaveHoliday = async () => {
        if (!holidayName) {
            setAlert({ open: true, message: 'Por favor, insira o nome do feriado.', severity: 'warning' });
            return;
        }
    
        const newHoliday = selectedDates[0]; // Selecionar a primeira data
        const formattedDate = moment(newHoliday).format('YYYY-MM-DD'); // Formatar a data para o formato YYYY-MM-DD
        
        // Log do payload a ser enviado
        console.log('Payload a ser enviado:', { nome: holidayName, data: formattedDate });
        
        try {
            const token = localStorage.getItem('access');
            
    
            // Chamar a API para salvar o feriado
            const response = await axios.post(`${apiBaseURL}/api/feriados/`, {
                nome: holidayName, // Certifique-se de usar "nome"
                data: formattedDate // Certifique-se de usar "data"
            }, {
                headers: {
                    Authorization: `Bearer ${token}`, // Adicionar token para autenticação
                    'Content-Type': 'application/json',
                }
            });
    
            // Log da resposta da API
            console.log('Resposta da API:', response.data);
    
            // Atualizar o estado local com o novo feriado
            setManualHolidays([...manualHolidays, { date: newHoliday, name: holidayName }]);
    
            // Fechar o modal e limpar o nome
            setIsHolidayModalOpen(false);
            setHolidayName('');
            setAlert({ open: true, message: `Feriado ${holidayName} marcado com sucesso!`, severity: 'success' });
    
        } catch (error) {
            // Log do erro completo para investigar a causa do problema
            console.error('Erro ao marcar feriado:', error.response ? error.response.data : error.message);
            console.log('Erro completo:', error);
    
            setAlert({ open: true, message: 'Erro ao marcar feriado.', severity: 'error' });
        }
    };
    
    
    
    const handleAddHoraExtra = async () => {
        const token = localStorage.getItem('access');
        if (!newHoraExtra.data || !newHoraExtra.horas_trabalhadas) {
            setAlert({ open: true, message: 'Por favor, preencha todos os campos obrigatórios.', severity: 'warning' });
            return;
        }
    
        const payload = {
            empregado: selectedEmpregado.id,
            data: newHoraExtra.data,
            horas_trabalhadas: parseFloat(newHoraExtra.horas_trabalhadas),
            justificativa: newHoraExtra.justificativa,
            aprovado_por: null,
            data_aprovacao: null,
        };
    
        try {
            await axios.post(`${apiBaseURL}/api/horas-extras/`, payload, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            setAlert({ open: true, message: 'Hora extra adicionada com sucesso!', severity: 'success' });
                        setOpenAddModal(false);
            setRefreshVersion(value => value + 1);
        } catch (error) {
            console.error('Erro ao adicionar hora extra:', error.response ? error.response.data : error.message);
            setAlert({ open: true, message: 'Erro ao adicionar hora extra.', severity: 'error' });
                }
    };

    useEffect(() => {
        fetchEmpregados();
        fetchFeriados();
        // Estas listas são globais e só precisam de ser carregadas ao abrir a página.
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const empregadoId = selectedEmpregado?.id;
    useEffect(() => {
        let cancelled = false;
        setAttendanceReady(false);
        setFerias([]);
        setFaltas([]);
        setBaixasMedicas([]);
        setAlteredDays([]);
        setTurnosRecords([]);
        setFeriasRecords([]);
        setHorasExtrasRecords([]);
        if (!empregadoId) return;
        const headers = { Authorization: `Bearer ${localStorage.getItem('access')}` };
        const loadAttendance = async () => {
            try {
                const [turnos, feriasData, faltasData, baixas, extras] = await Promise.all([
                    axios.get(`${apiBaseURL}/api/turnos/${empregadoId}/${ano}/${mes}/`, { headers }),
                    axios.get(`${apiBaseURL}/api/ferias/?empregado=${empregadoId}&ano=${ano}&mes=${mes}`, { headers }),
                    axios.get(`${apiBaseURL}/api/faltas/?empregado=${empregadoId}&ano=${ano}&mes=${mes}`, { headers }),
                    axios.get(`${apiBaseURL}/api/baixas-medicas/?empregado=${empregadoId}`, { headers }),
                    axios.get(`${apiBaseURL}/api/horas-extras/?empregado=${empregadoId}&mes=${mes}&ano=${ano}`, { headers }),
                ]);
                if (cancelled) return;
                setTurnosRecords(turnos.data);
                setFeriasRecords(feriasData.data);
                setAlteredDays(turnos.data.map(item => moment(item.data).toDate()));
                setFerias(feriasData.data.flatMap(item => (item.dias_ferias || '').split(',')
                    .filter(dia => dia.trim()).map(dia => moment(dia.trim()).toDate())));
                setFaltas(faltasData.data);
                setBaixasMedicas(baixas.data);
                setHorasExtrasRecords(extras.data.filter(item =>
                    moment(item.data).year() === ano && moment(item.data).month() + 1 === mes));
                setAttendanceReady(true);
            } catch (error) {
                if (!cancelled) setAlert({ open: true, severity: 'error', message: 'Erro ao carregar presenças. Tente selecionar o empregado novamente.' });
            }
        };
        loadAttendance();
        return () => { cancelled = true; };
    }, [empregadoId, ano, mes, refreshVersion]);

    useEffect(() => {
        setSelectedDates([]);
        setFocusedDate(null);
        setStartDate(null);
        setDistributionOpen(false);
        setDistributionPreview(null);
    }, [empregadoId, ano, mes]);

    const handleDistribution = async (confirmar = false) => {
        setDistributionBusy(true);
        setDistributionError('');
        try {
            const response = await axios.post(`${apiBaseURL}/api/horas-extras/distribuir/`, {
                empregado: selectedEmpregado.id, ano, mes,
                tipo: distributionType,
                total: distributionTotal.replace(',', '.'), confirmar,
                ...(confirmar ? { distribuicao: distributionPreview.distribuicao } : {}),
            }, { headers: { Authorization: `Bearer ${localStorage.getItem('access')}` } });
            if (confirmar) {
                setDistributionOpen(false);
                setRefreshVersion(value => value + 1);
                setAlert({ open: true, severity: 'success', message: `${response.data.total}h distribuídas por ${response.data.distribuicao.length} ${distributionType === 'sabados' ? 'sábados' : 'dias úteis'}.` });
            } else {
                setDistributionPreview(response.data);
            }
        } catch (error) {
            setDistributionPreview(null);
            const details = error.response?.data;
            setDistributionError(details?.detail || details?.total?.[0] || 'Não foi possível distribuir as horas. Tente novamente.');
        } finally {
            setDistributionBusy(false);
        }
    };

    const fetchEmpregados = async () => {
        const token = localStorage.getItem('access');
        try {
            const response = await axios.get(`${apiBaseURL}/api/empregados/`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            setEmpregados(response.data);
        } catch (error) {
            console.error('Erro ao buscar empregados:', error);
            setAlert({ open: true, message: 'Erro ao buscar empregados', severity: 'error' });
        }
    };

    const handleEmpregadoClick = (empregado) => {
        setSelectedEmpregado(empregado);
        setRefreshVersion(value => value + 1);
        fetchDiasRestantes(empregado.id, ano);
    };

    const handleOpenModal = () => {
        setModalOpen(true);
    };

    const handleCloseModal = () => {
        setModalOpen(false);
    };

    const handleSaveFalta = async () => {
        try {
            const token = localStorage.getItem('access');
            const formData = new FormData();
            formData.append('empregado', selectedEmpregado.id);
            formData.append('dia', newFalta.dia);
            formData.append('tipo_falta', newFalta.documento_justificacao ? 'justificada' : 'injustificada');
            formData.append('horario_inicio', newFalta.horario_inicio);
            formData.append('horario_fim', newFalta.horario_fim);
            if (newFalta.documento_justificacao) {
                formData.append('documento_justificacao', newFalta.documento_justificacao);
            }
            await axios.post(`${apiBaseURL}/api/faltas/`, formData, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'multipart/form-data',
                },
            });
            setAlert({ open: true, message: 'Falta adicionada com sucesso!', severity: 'success' });
            handleCloseModal();
            setRefreshVersion(value => value + 1);
        } catch (error) {
            setAlert({ open: true, message: 'Erro ao adicionar falta', severity: 'error' });
        }
    };

    const handleMarcarFerias = async () => {
        if (!selectedDates.length) {
            setAlert({ open: true, message: 'Selecione os dias primeiro', severity: 'error' });
            return;
        }
    
        // Se "Marcar meio dia" estiver ativo, só pode selecionar um dia
        if (isHalfDay && selectedDates.length > 1) {
            setAlert({ open: true, message: 'Só pode marcar um dia ao selecionar meio dia', severity: 'error' });
            return;
        }
    
        try {
            const token = localStorage.getItem('access');
    
            // Verifica se o empregado tem dias_restantes, caso contrário define como 22
            let diasRestantes = selectedEmpregado.dias_restantes !== undefined ? selectedEmpregado.dias_restantes : 22;
    
            const diasParaDescontar = isHalfDay ? 0.5 : 1; // Descontar meio dia ou um dia inteiro
    
            const payload = selectedDates.map((dia, index) => {
                const novoDiasRestantes = diasRestantes - diasParaDescontar * (index + 1); // Decremento acumulativo
                return {
                    empregado: selectedEmpregado.id,
                    ano: ano,
                    dias_restantes: isHalfDay ? diasRestantes - 0.5 : novoDiasRestantes, // Reduzir corretamente os dias_restantes
                    data_marcada: moment().format('YYYY-MM-DD'),  // Data de hoje
                    aprovado_por: 'Ines',
                    data_aprovacao: moment().format('YYYY-MM-DD'),  // Data de hoje
                    dias_ferias: moment(dia).format('YYYY-MM-DD'),  // Cada dia individualmente
                    half_day: isHalfDay,
                };
            });
    
            // Log do payload
            console.log("Payload para marcar férias:", payload);
    
            await Promise.all(
                payload.map(async (ferias) => {
                    const response = await axios.post(`${apiBaseURL}/api/ferias/`, ferias, {
                        headers: {
                            Authorization: `Bearer ${token}`,
                        },
                    });
                    console.log("Resposta da API para o dia:", ferias.dias_ferias, response.data);
                })
            );
    
            setAlert({ open: true, message: 'Férias marcadas com sucesso!', severity: 'success' });
            setRefreshVersion(value => value + 1);
        } catch (error) {
            // Log da resposta de erro
            console.error("Erro ao marcar férias:", error.response?.data || error.message);
            setAlert({ open: true, message: `Erro ao marcar férias: ${error.response?.data?.detail || error.message}`, severity: 'error' });
        }
    };

    const renderTileContent = ({ date, view }) => {
        if (view === 'month') {
            const isFaltaDay = faltas.find((f) => moment(f.dia).isSame(date, 'day'));
            return (
                <div
                    onDoubleClick={() => { if (isFaltaDay) handleDateDoubleClick(date); }}
                    style={{ width: '100%', height: '100%' }}
                >
                    {isFaltaDay && (
                        <div
                            className="falta-indicator"
                            style={{ backgroundColor: 'orange', borderRadius: '50%', width: '10px', height: '10px', margin: 'auto' }}
                        />
                    )}
                </div>
            );
        }
        return null;
    };

    const handleDateDoubleClick = (date) => {
        const falta = faltas.find((f) => moment(f.dia).isSame(date, 'day'));
        console.log("click");
        if (falta) {
            setSelectedFalta(falta);
            setFaltaModalOpen(true);
        } else {
            setAlert({ open: true, message: 'Detalhes da falta não encontrados.', severity: 'error' });
        }
    };

    const handleDateClick = (date) => {
        setFocusedDate(moment(date).format('YYYY-MM-DD'));
        setSelectedDates([date]);
        setNewFalta((prev) => ({
            ...prev,
            dia: moment(date).format('YYYY-MM-DD'), // Formata a data para o campo de falta
        }));
        setNewHoraExtra((prev) => ({
            ...prev,
            data: moment(date).format('YYYY-MM-DD'), // Formata a data para o campo de hora extra
        }));
    
   
        if (isMultiDaySelection) {
            if (!startDate) {
                // Se a data de início não estiver definida, define a data inicial
                setStartDate(date);
                setSelectedDates([date]);  // Seleciona o primeiro dia imediatamente
            } else {
                // Seleciona todos os dias úteis no intervalo entre a data inicial e a data clicada
                const endDate = date;
                const allDates = getWorkingDaysInRange(startDate, endDate);
                setSelectedDates(allDates); // Substitui os dias selecionados com o novo intervalo
                setStartDate(null); // Reinicia a data de início
            }
        } else {
            setSelectedDates([date]);
        }
    };

// Função para verificar se um dia é útil (segunda a sexta)
const isWorkingDay = (date) => {
    const dayOfWeek = date.getDay();
    return dayOfWeek !== 0 && dayOfWeek !== 6; // 0 é domingo e 6 é sábado
};

const getWorkingDaysInRange = (start, end) => {
    const range = [];
    let currentDate = new Date(start <= end ? start : end);
    const lastDate = start <= end ? end : start;

    // Gera o intervalo de dias úteis
    while (currentDate <= lastDate) {
        if (isWorkingDay(currentDate)) {
            range.push(new Date(currentDate));
        }
        currentDate.setDate(currentDate.getDate() + 1); // Avança um dia
    }
    return range;
};

// Ao iniciar a geração, exibe o spinner
const iniciarGeracaoFolhas = async (ano, mes) => {
    setLoading(true); // Abre a modal com spinner
    console.log('Ano:', ano, 'Mes:', mes);
    const token = localStorage.getItem('access');
    try {
      const data = { ano, mes };
      console.log('Dados a serem enviados:', data);
      
      const response = await axios.post(`${apiBaseURL}/api/presenca/gerar/`, data, {
        headers: {
          Authorization: `Bearer ${token}`,
          'X-CSRFToken': csrfToken,
        }
      });
      const taskId = response.data.task_id;
      console.log(`Task ID obtido: ${taskId}`);
      acompanharStatusTarefa(taskId, ano, mes);
    } catch (error) {
      console.error('Erro ao iniciar a geração das folhas de presença:', error);
      setAlert({ open: true, message: 'Erro ao iniciar a geração das folhas de presença.', severity: 'error' });
      setLoading(false); // Fecha a modal em caso de erro
      return null;
    }
  };

// Função para verificar o status da tarefa
const verificarStatus = async (taskId) => {
    const token = localStorage.getItem('access');
    try {
      const response = await axios.get(`${apiBaseURL}/api/presenca/status/${taskId}/`, {
        headers: {
          Authorization: `Bearer ${token}`,
          'X-CSRFToken': csrfToken,
        },
      });
      return response.data.status; // Ex.: 'PENDING', 'STARTED', 'SUCCESS'
    } catch (error) {
      console.error('Erro ao verificar o status da tarefa:', error);
      setAlert({ open: true, message: 'Erro ao verificar o status da tarefa.', severity: 'error' });
      return null;
    }
  };
  const acompanharStatusTarefa = async (taskId, ano, mes) => {
    const interval = setInterval(async () => {
      const status = await verificarStatus(taskId);
      console.log(`Status atual da tarefa ${taskId}: ${status}`);
      
      if (status === 'SUCCESS') {
        clearInterval(interval); // Para o polling
        setAlert({ open: true, message: 'Folhas de presença geradas com sucesso!', severity: 'success' });
        await handleDownload(ano, mes); // Inicia o download e aguarda sua conclusão
        // O handleDownload deve definir loading como false ao terminar
      } else if (status === 'FAILURE') {
        clearInterval(interval);
        setAlert({ open: true, message: 'Erro ao gerar as folhas de presença.', severity: 'error' });
        setLoading(false);
      }
      // Se o status for PENDING ou STARTED, continua o polling
    }, 3000); // Verifica a cada 3 segundos
  };

// Função para baixar o arquivo ZIP e encerrar o spinner
const handleDownload = async (ano, mes) => {
    const token = localStorage.getItem('access');
    try {
      const response = await axios.get(`${apiBaseURL}/api/presenca/download/${ano}/${mes}/`, {
        headers: {
          Authorization: `Bearer ${token}`,
          'X-CSRFToken': csrfToken,
        },
        responseType: 'blob',
      });
    
      const blob = new Blob([response.data], { type: 'application/zip' });
      saveAs(blob, `folhas_de_presenca_${ano}_${mes}.zip`);
      setLoading(false); // Fecha a modal após o download
    } catch (error) {
      console.error('Erro ao baixar as folhas de presença:', error);
      setAlert({ open: true, message: 'Erro ao baixar o arquivo das folhas de presença.', severity: 'error' });
      setLoading(false);
    }
  };


// Função para salvar as alterações de turno
const handleSaveChanges = async () => {
    const token = localStorage.getItem('access');
    const csrftoken = document.cookie
        .split('; ')
        .find(row => row.startsWith('csrftoken'))
        ?.split('=')[1];

    try {
        const payload = {
            empregado_id: selectedEmpregado.id,
            ano,
            mes,
            dias: selectedDates.map(date => moment(date).format('YYYY-MM-DD')),  // Converter datas para strings no formato correto
            turno,  // Turno selecionado
        };

        console.log("Payload de alteração de turno:", payload);

        await axios.post(`${apiBaseURL}/api/salvar-turno/`, payload, {
            headers: {
                'X-CSRFToken': csrftoken,
                'Authorization': `Bearer ${token}`,
            },
        });
        setAlert({ open: true, message: 'Mudanças de turno salvas com sucesso', severity: 'success' });
        setRefreshVersion(value => value + 1);

        if (!empregadosAlterados.includes(selectedEmpregado.id)) {
            setEmpregadosAlterados([...empregadosAlterados, selectedEmpregado.id]);
        }
    } catch (error) {
        console.error('Erro ao salvar alterações de turno:', error.response?.data || error.message);
        setAlert({ open: true, message: 'Erro ao salvar alterações de turno', severity: 'error' });
    }
};

const handleFullDayChange = (e) => {
    const isChecked = e.target.checked;
    setIsFullDay(isChecked);

    if (isChecked && selectedEmpregado) {
        // Preencher os horários de início e fim com base no turno do empregado
        switch (selectedEmpregado.turno) {
            case 'manha-1':
                setNewFalta({
                    ...newFalta,
                    horario_inicio: '05:00',
                    horario_fim: '13:00',
                });
                break;
            case 'manha':
                setNewFalta({
                    ...newFalta,
                    horario_inicio: '06:00',
                    horario_fim: '14:00',
                });
                break;
            case 'tarde':
                setNewFalta({
                    ...newFalta,
                    horario_inicio: '14:00',
                    horario_fim: '22:00',
                });
                break;
            case 'noite':
                setNewFalta({
                    ...newFalta,
                    horario_inicio: '22:00',
                    horario_fim: '06:00',
                });
                break;
            case 'normal':
                setNewFalta({
                    ...newFalta,
                    horario_inicio: '09:00',
                    horario_fim: '18:00',
                });
                break;
            case 'horario_amamentacao':
                setNewFalta({
                    ...newFalta,
                    horario_inicio: '11:00',
                    horario_fim: '18:00',
                });
                break;
            default:
                setNewFalta({
                    ...newFalta,
                    horario_inicio: '',
                    horario_fim: '',
                });
                break;
        }
    } else {
        // Limpar os horários se o checkbox for desmarcado
        setNewFalta({
            ...newFalta,
            horario_inicio: '',
            horario_fim: '',
        });
    }
};

const fetchDiasRestantes = async (empregadoId, ano) => {
    const token = localStorage.getItem('access');
    try {
        const response = await axios.get(`${apiBaseURL}/api/ferias/?empregado=${empregadoId}&ano=${ano}`, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });

        if (response.data.length > 0) {
            // Encontra o último registro de férias com base no maior ID
            const feriasMaisRecente = response.data.reduce((prev, current) => {
                return (prev.id > current.id) ? prev : current; // Compara os IDs para garantir que o mais recente seja o maior
            });

            setSelectedEmpregado(prev => prev?.id !== empregadoId ? prev : ({
                ...prev,
                dias_restantes: feriasMaisRecente.dias_restantes
            }));
        } else {
            setSelectedEmpregado(prev => prev?.id !== empregadoId ? prev : ({
                ...prev,
                dias_restantes: 22 // Valor padrão se não houver férias registradas
            }));
        }
    } catch (error) {
        console.error('Erro ao buscar os dias restantes de férias:', error);
    }
};

const handleSearchChange = (event) => {
    setSearchTerm(event.target.value); // Atualiza o termo de pesquisa conforme o usuário digita
};
// Filtrar a lista de empregados com base no termo de pesquisa
const filteredEmpregados = empregados.filter((empregado) =>
    empregado.nome_completo.toLowerCase().includes(searchTerm.toLowerCase())
);

const getTileClassName = ({ date }) => {
    const dayOfWeek = date.getDay();
    const monthInDropdown = mes - 1; // Mês selecionado, -1 porque Date usa 0 para janeiro
    const yearInDropdown = ano; // Ano selecionado

    // Verifica se a data pertence ao mês e ano selecionados nas dropdowns
    if (date.getMonth() === monthInDropdown && date.getFullYear() === yearInDropdown) {
        if (selectedDates.find(d => moment(d).isSame(date, 'day'))) {
            return 'selected-day';  // Dias com turnos selecionados em azul
        }
        if (ferias.find(f => moment(f).isSame(date, 'day'))) {
            return 'ferias-day';  // Dias de férias em vermelho
        }
        if (faltas.find(f => moment(f.dia).isSame(date, 'day'))) {
            return 'falta-day';  // Dias de faltas em laranja
        }
        if (baixasMedicas.some(baixa => moment(date).isBetween(baixa.data_inicio, baixa.data_fim, 'day', '[]'))) {
            return 'baixa-day';
        }
        if (alteredDays.find(a => moment(a).isSame(date, 'day'))) {
            return 'turno-alterado-day';  // Dias com alteração de turno em verde escuro
        }
        if (feriados.find(f => moment(f.date).isSame(date, 'day'))) {  // Verifica os feriados da base de dados
            return 'feriado-day';  // Dias de feriados em uma cor diferente, por exemplo, roxo
        }
        if (horasExtrasDates.find(h => moment(h).isSame(date, 'day'))) {
            return 'horas-extras-day'; // Dias com horas extras em azul clarinho
        }
        if (manualHolidays.find(h => moment(h.date).isSame(date, 'day'))) {
            return 'feriado-manual-day';  // Feriados marcados manualmente
        }
        if (dayOfWeek !== 0 && dayOfWeek !== 6) {
            return 'normal-day';  // Dias úteis (segunda a sexta) em verde claro
        }
    }

    return '';  // Finais de semana ou dias fora do mês/ano selecionado sem cor específica
};

    return (
        <Box className="attendance-page" sx={{ display: 'flex', flexDirection: { xs: 'column', md: 'row' }, minHeight: '100vh', width: '100%', bgcolor: '#f5f7fb' }}>
            <Box component="aside" sx={{ width: { xs: '100%', md: 280 }, flexShrink: 0, p: 2.5, bgcolor: 'background.paper', borderRight: '1px solid #e2e8f0', boxSizing: 'border-box' }}>
                <Typography variant="h6" sx={{ fontWeight: 700, mb: 2 }}>Empregados</Typography>
                <TextField label="Procurar empregado" size="small" fullWidth value={searchTerm} onChange={handleSearchChange} sx={{ mb: 2 }} />
                <Box sx={{ maxHeight: { xs: 220, md: '65vh' }, overflowY: 'auto', mb: 2 }}>
                    <TableContainer>
                        <Table size="small" aria-label="Lista de empregados">
                            <TableBody>
                                {filteredEmpregados.map(empregado => (
                                    <TableRow key={empregado.id} selected={selectedEmpregado?.id === empregado.id}>
                                        <TableCell sx={{ p: 0, borderBottom: '1px solid #f1f5f9' }}>
                                            <Button fullWidth onClick={() => handleEmpregadoClick(empregado)} aria-pressed={selectedEmpregado?.id === empregado.id}
                                                sx={{ justifyContent: 'flex-start', textAlign: 'left', textTransform: 'none', py: 1.5, px: 1.5, fontWeight: selectedEmpregado?.id === empregado.id ? 700 : 400 }}>
                                                {empregado.nome_completo}
                                            </Button>
                                        </TableCell>
                                    </TableRow>
                                ))}
                                {!filteredEmpregados.length && <TableRow><TableCell>Nenhum empregado encontrado.</TableCell></TableRow>}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Box>
                <Button fullWidth variant="outlined" onClick={() => iniciarGeracaoFolhas(ano, mes)} disabled={loading} startIcon={<Download />}>
                    Download alterações
                </Button>
                <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 1 }}>Folhas de presença de {moment.months(mes - 1)} de {ano}.</Typography>
            </Box>

            <Box component="main" sx={{ flex: 1, minWidth: 0, p: { xs: 2, lg: 4 } }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 2, flexWrap: 'wrap', mb: 3 }}>
                    <Box>
                        <Typography variant="overline" color="text.secondary">Gestão de presenças</Typography>
                        <Typography component="h1" variant="h5" sx={{ fontWeight: 700 }}>{selectedEmpregado?.nome_completo || 'Folhas de presença'}</Typography>
                        {selectedEmpregado && <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>Férias restantes: {selectedEmpregado.dias_restantes ?? '—'} dias · Turno: {selectedEmpregado.turno}</Typography>}
                    </Box>
                    <Box sx={{ display: 'flex', gap: 1.5 }}>
                        <FormControl size="small" sx={{ minWidth: 100 }}>
                            <InputLabel id="attendance-year-label">Ano</InputLabel>
                            <Select labelId="attendance-year-label" label="Ano" value={ano} onChange={e => setAno(e.target.value)}>
                                {years.map(year => <MenuItem key={year} value={year}>{year}</MenuItem>)}
                            </Select>
                        </FormControl>
                        <FormControl size="small" sx={{ minWidth: 145 }}>
                            <InputLabel id="attendance-month-label">Mês</InputLabel>
                            <Select labelId="attendance-month-label" label="Mês" value={mes} onChange={e => setMes(e.target.value)}>
                                {moment.months().map((month, index) => <MenuItem key={month} value={index + 1}>{month}</MenuItem>)}
                            </Select>
                        </FormControl>
                    </Box>
                </Box>
                {!selectedEmpregado ? (
                    <Alert severity="info">Selecione um empregado para consultar e gerir as presenças.</Alert>
                ) : !attendanceReady ? (
                    <Box role="status" sx={{ display: 'flex', alignItems: 'center', gap: 2, py: 4 }}><CircularProgress size={24} /><Typography>A carregar presenças…</Typography></Box>
                ) : (
                    <>
                        <Grid container spacing={2} sx={{ mb: 3 }}>
                            {[
                                ['Horas da semana', horasExtras.totalSemana, 'Dias úteis, excluindo feriados'],
                                ['Sábados e feriados', horasExtras.totalSabadosFeriados, 'Contados uma única vez'],
                                ['Domingos', horasExtras.totalDomingos, 'Excluindo os domingos feriados'],
                            ].map(([label, total, description]) => (
                                <Grid item xs={12} sm={4} key={label}>
                                    <Box sx={{ bgcolor: 'background.paper', border: '1px solid #e2e8f0', borderRadius: 2, p: 2 }}>
                                        <Typography variant="body2" color="text.secondary">{label}</Typography>
                                        <Typography variant="h5" sx={{ fontWeight: 700, my: 0.5 }}>{total.toLocaleString('pt-PT')} h</Typography>
                                        <Typography variant="caption" color="text.secondary">{description}</Typography>
                                    </Box>
                                </Grid>
                            ))}
                        </Grid>
                        <Box sx={{ display: 'flex', gap: 1.5, flexWrap: 'wrap', mb: 2.5 }}>
                            <Button variant="contained" onClick={() => openDistribution('semana')}>Dividir horas da semana</Button>
                            <Button variant="contained" color="secondary" onClick={() => openDistribution('sabados')}>Dividir horas dos sábados</Button>
                            <Button variant="outlined" disabled={!focusedDate} onClick={handleOpenAddModal}>Adicionar horas extra num dia</Button>
                        </Box>
                        <Grid container spacing={3} alignItems="flex-start">
                            <Grid item xs={12} md={7}>
                                <Box sx={{ bgcolor: 'background.paper', border: '1px solid #e2e8f0', borderRadius: 2, p: { xs: 1.5, sm: 2.5 } }}>
                                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', mb: 2 }}>
                                        <Typography variant="h6" sx={{ fontWeight: 600 }}>Calendário</Typography>
                                        <Typography variant="body2" color="text.secondary">{selectedDates.length} dia(s) selecionado(s)</Typography>
                                    </Box>
                                    <Calendar locale="pt-PT" onClickDay={handleDateClick} value={null}
                                        activeStartDate={new Date(ano, mes - 1, 1)}
                                        onActiveStartDateChange={({ activeStartDate }) => {
                                            if (activeStartDate) { setAno(activeStartDate.getFullYear()); setMes(activeStartDate.getMonth() + 1); }
                                        }}
                                        minDate={new Date(2020, 0, 1)} maxDate={new Date(moment().year(), 11, 31)}
                                        showNeighboringMonth={false} minDetail="month"
                                        tileClassName={getTileClassName} tileContent={renderTileContent} />
                                    <FormControlLabel control={<Checkbox checked={isMultiDaySelection} onChange={e => { setIsMultiDaySelection(e.target.checked); setStartDate(null); }} />} label="Selecionar intervalo de dias úteis" />
                                    <Box sx={{ display: 'flex', gap: 1.5, flexWrap: 'wrap', mt: 1.5 }}>
                                        {[
                                            ['Selecionado', '#2563eb'], ['Férias', '#fecaca'], ['Falta', '#fed7aa'],
                                            ['Baixa médica', '#ddd6fe'], ['Dia útil', '#dcfce7'], ['Turno alterado', '#166534'],
                                            ['Feriado', '#fef08a'], ['Horas extra', '#bae6fd'],
                                        ].map(([label, color]) => <Box key={label} sx={{ display: 'flex', alignItems: 'center', gap: 0.75 }}><Box sx={{ width: 10, height: 10, borderRadius: '3px', bgcolor: color }} /><Typography variant="caption" color="text.secondary">{label}</Typography></Box>)}
                                    </Box>
                                </Box>
                            </Grid>
                            <Grid item xs={12} md={5}>
                                <Box sx={{ bgcolor: 'background.paper', border: '1px solid #e2e8f0', borderRadius: 2 }}>
                                    <AttendanceDayDetails key={`${empregadoId}:${focusedDate}`} date={focusedDate} details={dayDetails}
                                        apiBaseURL={apiBaseURL} onOvertimeChange={handleDayOvertimeChange} onAddOvertime={handleOpenAddModal} />
                                </Box>
                            </Grid>
                            <Grid item xs={12}>
                                <Box sx={{ bgcolor: 'background.paper', border: '1px solid #e2e8f0', borderRadius: 2, p: 2.5 }}>
                                    <Typography variant="h6" sx={{ fontWeight: 600, mb: 1 }}>Ações nos dias selecionados</Typography>
                                    <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>{selectedDates.length} dia(s) selecionado(s). Use a seleção de intervalo para aplicar férias ou turnos a vários dias.</Typography>
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, flexWrap: 'wrap', mb: 3 }}>
                                        <Button variant="outlined" disabled={selectedDates.length !== 1} onClick={handleOpenModal}>Adicionar falta</Button>
                                        <Button variant="outlined" disabled={!selectedDates.length} onClick={handleMarcarFerias}>Marcar férias</Button>
                                        <FormControlLabel control={<Checkbox checked={isHalfDay} onChange={e => setIsHalfDay(e.target.checked)} />} label="Meio dia de férias" />
                                        <Button variant="text" disabled={selectedDates.length !== 1} onClick={handleMarkHoliday}>Marcar como feriado</Button>
                                        <Button variant="text" disabled={!selectedDates.length} onClick={() => { setSelectedDates([]); setStartDate(null); }}>Limpar seleção</Button>
                                    </Box>
                                    <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 2 }}>Alterar turno dos dias selecionados</Typography>
                                    <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
                                        <FormControl size="small" sx={{ flex: 1, minWidth: 220 }}>
                                            <InputLabel id="attendance-shift-label">Turno</InputLabel>
                                            <Select labelId="attendance-shift-label" label="Turno" value={turno} onChange={e => setTurno(e.target.value)}>
                                                <MenuItem value="normal">Normal</MenuItem>
                                                <MenuItem value="manha">Manhã</MenuItem>
                                                <MenuItem value="tarde">Tarde</MenuItem>
                                                <MenuItem value="noite">Noite</MenuItem>
                                                <MenuItem value="manha-1">Manhã-1</MenuItem>
                                                <MenuItem value="horario_amamentacao">Horário de Amamentação</MenuItem>
                                                <MenuItem value="horario_amamentacao_tarde">Horário de Amamentação Tarde</MenuItem>
                                                <MenuItem value="horario_amamentacao_manha_tarde">Horário de Amamentação Manhã Tarde</MenuItem>
                                                <MenuItem value="horario_amamentacao_1_tarde">Horário de Amamentação -1 Tarde</MenuItem>
                                            </Select>
                                        </FormControl>
                                        <Button variant="contained" disabled={!selectedDates.length} onClick={handleSaveChanges}>Guardar alterações</Button>
                                    </Box>
                                </Box>
                            </Grid>
                        </Grid>
                    </>
                )}
            </Box>

            <Dialog open={distributionOpen} onClose={() => { if (!distributionBusy) setDistributionOpen(false); }} fullWidth maxWidth="sm" aria-labelledby="distribution-title">
                <DialogTitle id="distribution-title">{distributionType === 'sabados' ? 'Dividir horas dos sábados' : 'Dividir horas da semana'}</DialogTitle>
                <DialogContent>
                    <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>{selectedEmpregado?.nome_completo} · {moment.months(mes - 1)} de {ano}</Typography>
                    <Alert severity="info" sx={{ mb: 2 }}>O total será acrescentado aos registos existentes e dividido pelos {distributionType === 'sabados' ? 'sábados' : 'dias úteis'} disponíveis. Dias com faltas, férias (incluindo meios dias) e baixas ficam excluídos.{distributionType === 'semana' ? ' Os feriados também ficam excluídos.' : ' Um sábado feriado é contado uma única vez.'}</Alert>
                    <TextField autoFocus fullWidth label="Total de horas a distribuir" type="number" value={distributionTotal} disabled={distributionBusy}
                        onChange={e => { setDistributionTotal(e.target.value); setDistributionPreview(null); setDistributionError(''); }}
                        inputProps={{ min: 0.01, max: 999.99, step: 0.01 }} helperText="Horas decimais: por exemplo, 1,5 h corresponde a 1 h e 30 min." sx={{ mt: 1 }} />
                    {distributionError && <Alert severity="error" sx={{ mt: 2 }}>{distributionError}</Alert>}
                    {distributionPreview && <Box sx={{ mt: 2 }}>
                        <Typography sx={{ mb: 1, fontWeight: 600 }}>{distributionPreview.total} h em {distributionPreview.distribuicao.length} dias</Typography>
                        <TableContainer sx={{ maxHeight: 260 }}>
                            <Table size="small" aria-label="Pré-visualização da distribuição"><TableBody>
                                {distributionPreview.distribuicao.map(dia => <TableRow key={dia.data}><TableCell>{moment(dia.data).format('ddd, DD/MM/YYYY')}</TableCell><TableCell align="right">{Number(dia.horas_trabalhadas).toLocaleString('pt-PT')} h</TableCell></TableRow>)}
                            </TableBody></Table>
                        </TableContainer>
                        <Typography variant="caption" color="text.secondary">O arredondamento a duas casas decimais mantém o total exato.</Typography>
                    </Box>}
                </DialogContent>
                <DialogActions sx={{ p: 2 }}>
                    <Button disabled={distributionBusy} onClick={() => setDistributionOpen(false)}>Cancelar</Button>
                    <Button variant="contained" disabled={distributionBusy || !Number.isFinite(Number(distributionTotal)) || Number(distributionTotal) <= 0}
                        onClick={() => handleDistribution(Boolean(distributionPreview))}>
                        {distributionBusy ? 'A processar…' : distributionPreview ? 'Guardar distribuição' : 'Pré-visualizar distribuição'}
                    </Button>
                </DialogActions>
            </Dialog>

            <Snackbar
                open={alert.open}
                autoHideDuration={6000}
                onClose={() => setAlert({ ...alert, open: false })}
            >
                <Alert onClose={() => setAlert({ ...alert, open: false })} severity={alert.severity}>
                    {alert.message}
                </Alert>
            </Snackbar>

            {/* Modal de Loading */}
            <Backdrop open={loading} sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}>
                <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                    <CircularProgress color="inherit" />
                    <Typography variant="h6" sx={{ mt: 2 }}>
                        Estou a preencher os dados solicitados...
                    </Typography>
                </Box>
            </Backdrop>

            <Modal open={modalOpen} onClose={handleCloseModal}>
                <Box sx={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', width: 'min(400px, calc(100vw - 32px))', maxHeight: '90vh', overflowY: 'auto', boxSizing: 'border-box', bgcolor: 'background.paper', boxShadow: 24, p: 4 }}>
                    <Typography id="modal-title" variant="h6" component="h2">
                        Adicionar Falta
                    </Typography>
                    <TextField
                        label="Empregado"
                        fullWidth
                        margin="normal"
                        value={selectedEmpregado?.nome_completo || ''}
                        disabled
                    />
                    <TextField
                        label="Dia"
                        type="date"
                        name="dia"
                        fullWidth
                        margin="normal"
                        InputLabelProps={{ shrink: true }}
                        value={newFalta.dia}
                        onChange={(e) => setNewFalta({ ...newFalta, dia: e.target.value })}
                    />
                    <FormControlLabel
    control={
        <Checkbox
            checked={isFullDay}
            onChange={handleFullDayChange}
            color="primary"
        />
    }
    label="Dia inteiro"
/>
                    <TextField
                        label="Horário de Início"
                        type="time"
                        name="horario_inicio"
                        fullWidth
                        margin="normal"
                        InputLabelProps={{ shrink: true }}
                        value={newFalta.horario_inicio}
                        disabled={isFullDay}
                        onChange={(e) => setNewFalta({ ...newFalta, horario_inicio: e.target.value })}
                    />
                    <TextField
                        label="Horário de Fim"
                        type="time"
                        name="horario_fim"
                        fullWidth
                        margin="normal"
                        InputLabelProps={{ shrink: true }}
                        value={newFalta.horario_fim}
                        disabled={isFullDay}
                        onChange={(e) => setNewFalta({ ...newFalta, horario_fim: e.target.value })}
                    />
                    <Button
                        variant="contained"
                        component="label"
                        color="primary"
                        fullWidth
                        sx={{ mt: 2 }}
                    >
                        Anexar Documento de Justificação
                        <input
                            type="file"
                            hidden
                            onChange={(e) => setNewFalta({ ...newFalta, documento_justificacao: e.target.files[0] })}
                        />
                    </Button>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', marginTop: 2 }}>
                        <Button onClick={handleCloseModal} variant="contained" color="secondary">
                            Cancelar
                        </Button>
                        <Button onClick={handleSaveFalta} variant="contained" color="primary">
                            Salvar Falta
                        </Button>
                    </Box>
                </Box>
            </Modal>
            <Modal
    open={openAddModal}
    onClose={handleCloseModals}
    aria-labelledby="modal-add-hora-extra"
    aria-describedby="modal-add-hora-extra-description"
>
    <Box
        sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 'min(400px, calc(100vw - 32px))', maxHeight: '90vh', overflowY: 'auto', boxSizing: 'border-box',
            bgcolor: 'background.paper',
            boxShadow: 24,
            p: 4,
            borderRadius: 2,
        }}
    >
        <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
            <Typography variant="h6">
                Adicionar Hora Extra para {selectedEmpregado?.nome_completo}
            </Typography>
            <IconButton onClick={handleCloseModals}>
                <Close />
            </IconButton>
        </Box>
        <TextField
            label="Data"
            type="date"
            name="data"
            fullWidth
            margin="normal"
            InputLabelProps={{ shrink: true }}
            value={newHoraExtra.data}
            onChange={handleNewHoraExtraChange}
            inputProps={{
                max: moment().format('YYYY-MM-DD'),
            }}
        />
        <TextField
            label="Horas Trabalhadas"
            type="number"
            name="horas_trabalhadas"
            fullWidth
            margin="normal"
            InputProps={{ inputProps: { min: 0.5, step: 0.5 } }}
            value={newHoraExtra.horas_trabalhadas}
            onChange={handleNewHoraExtraChange}
        />
        <TextField
            style={{ display: 'none' }}  // Corrigido: style como objeto e chave 'display' entre chaves duplas

            label="Justificação"
            name="justificativa"
            fullWidth
            margin="normal"
            multiline
            rows={4}
            value={newHoraExtra.justificativa}
            onChange={handleNewHoraExtraChange}
        />
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>
            <Button variant="contained" color="primary" onClick={handleAddHoraExtra}>
                Adicionar
            </Button>
        </Box>
    </Box>
</Modal>
<Modal
    open={isHolidayModalOpen}
    onClose={handleCloseHolidayModal}
    aria-labelledby="holiday-modal-title"
    aria-describedby="holiday-modal-description"
>
    <Box
        sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 'min(400px, calc(100vw - 32px))', maxHeight: '90vh', overflowY: 'auto', boxSizing: 'border-box',
            bgcolor: 'background.paper',
            boxShadow: 24,
            p: 4,
            borderRadius: 2
        }}
    >
        <Typography id="holiday-modal-title" variant="h6" component="h2">
            Inserir o nome do Feriado
        </Typography>
        <TextField
            label="Nome do Feriado"
            fullWidth
            value={holidayName}
            onChange={(e) => setHolidayName(e.target.value)}
            margin="normal"
        />
        <Button
            variant="contained"
            color="primary"
            onClick={handleSaveHoliday}
            sx={{ mt: 2 }}
        >
            Salvar Feriado
        </Button>
        <Button
            variant="contained"
            color="secondary"
            onClick={handleCloseHolidayModal}
            sx={{ mt: 2, ml: 2 }}
        >
            Cancelar
        </Button>
    </Box>
</Modal>
<Modal
    open={faltaModalOpen}
    onClose={() => setFaltaModalOpen(false)}
    aria-labelledby="falta-modal-title"
    aria-describedby="falta-modal-description"
>
    <Box
        sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 'min(400px, calc(100vw - 32px))', maxHeight: '90vh', overflowY: 'auto', boxSizing: 'border-box',
            bgcolor: 'background.paper',
            boxShadow: 24,
            p: 4,
            borderRadius: 2,
        }}
    >
        <Typography id="falta-modal-title" variant="h6" component="h2">
            Detalhes da Falta
        </Typography>
        {selectedFalta && (
            <>
                <Typography>Dia: {moment(selectedFalta.dia).format('DD/MM/YYYY')}</Typography>
                <Button
                    variant="contained"
                    component="label"
                    color="primary"
                    fullWidth
                    sx={{ mt: 2 }}
                >
                    Carregar Justificação
                    <input
                        type="file"
                        hidden
                        onChange={(e) => setNewFalta({ ...newFalta, documento_justificacao: e.target.files[0] })}
                    />
                </Button>
            </>
        )}
        <Box sx={{ display: 'flex', justifyContent: 'space-between', marginTop: 2 }}>
            <Button onClick={() => setFaltaModalOpen(false)} variant="contained" color="secondary">
                Fechar
            </Button>
        </Box>
    </Box>
</Modal>

        </Box>
    );
};

export default Folhasdepresençav2;
